export const getAuthApiBases = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isProduction = hostname.includes('prosecaptain.com');
  const productionBases = [
    'https://api.prosecaptain.com'
  ];
  const localBases = [
    window.location.origin,
    'https://api.prosecaptain.com',
    'http://localhost:4001',
    'http://localhost:4002'
  ];

  if (isLocalhost) {
    return localBases;
  }

  if (isProduction) {
    return productionBases;
  }

  return [window.location.origin, ...productionBases];
};

export const postAuthEndpoint = async (path, payload) => {
  const bases = getAuthApiBases();
  let lastNetworkError = null;
  let lastHttpError = null;

  for (const base of bases) {
    try {
      const response = await fetch(`${base}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json().catch(() => ({}));
      if (response.status >= 500 || response.status === 404 || response.status === 405) {
        lastHttpError = { status: response.status, data };
        continue;
      }
      return { ok: response.ok, status: response.status, data };
    } catch (error) {
      lastNetworkError = error;
    }
  }

  if (lastHttpError) {
    return { ok: false, status: lastHttpError.status, data: lastHttpError.data };
  }

  if (lastNetworkError) {
    throw new Error('Authentication service is unavailable right now. Please try again in a moment.');
  }
  throw new Error('Unable to reach authentication service.');
};
